import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navigation from "./components/kedve/Navigation";
import Footer from "./components/kedve/Footer";
import BackgroundMotion from "./components/kedve/BackgroundMotion";
import Home from "./pages/Home";
import CareerJourney from "./pages/CareerJourney";
import Accelerators from "./pages/Accelerators";
import Enterprise from "./pages/Enterprise";
import Philosophy from "./pages/Philosophy";
import Apply from "./pages/Apply";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App bg-white text-black relative overflow-x-hidden">
      <BrowserRouter>
        <ScrollToTop />
        <BackgroundMotion />
        <Navigation />
        <main className="relative z-10">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/career-journey" element={<CareerJourney />} />
            <Route path="/accelerators" element={<Accelerators />} />
            <Route path="/enterprise" element={<Enterprise />} />
            <Route path="/philosophy" element={<Philosophy />} />
            <Route path="/apply" element={<Apply />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
